import React, {useCallback} from "react";
import {Col, Row, Select} from "antd";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {
    DateRangeFilter,
    DynamicCityFilter,
    DynamicDistrictFilter
} from "components/_defaultComponents/FilterComponents";
import {ZoneManagementSelect} from "components/_defaultComponents/ZoneManagementSelect/ZoneManagementSelect";
import {DebouncedInput} from "components/tickets/common/DebouncedInput";
import {APPLICATION_STATUSES, APPLICATION_TYPES} from "constants/application";

export const ApplicationFilters = ({type, filters, onChange, extra}) => {
    const {t} = useTranslation(["applications"]);
    const stores = useStore();
    const isAgency = type === APPLICATION_TYPES.agency;
    const showZoneManagement =
        isAgency && stores.meStore.checkRole("applicationZoneManagementFilter");

    const handleSearchChange = useCallback(value => onChange({search: value}), [onChange]);

    return (
        <Row gutter={[16, 16]} style={{marginBottom: 16}} align="middle">
            <Col xs={24} sm={12} md={6}>
                <DateRangeFilter
                    showLabel={false}
                    value={filters.dateRange}
                    placeholder={t("list.filters.dateRange", {
                        ns: "applications",
                        returnObjects: true
                    })}
                    onChange={dateRange => onChange({dateRange})}
                />
            </Col>
            <Col xs={24} sm={12} md={6}>
                <DynamicCityFilter
                    showLabel={false}
                    allowClear
                    selectMarginBottom="0px"
                    placeholder={t("list.filters.city", {ns: "applications"})}
                    style={{width: "100%"}}
                    value={filters.cityId || undefined}
                    onChange={value => onChange({cityId: value || "", districtId: ""})}
                />
            </Col>
            <Col xs={24} sm={12} md={6}>
                <DynamicDistrictFilter
                    showLabel={false}
                    allowClear
                    selectMarginBottom="0px"
                    cityId={filters.cityId}
                    disabled={!filters.cityId}
                    placeholder={t("list.filters.district", {ns: "applications"})}
                    style={{width: "100%"}}
                    value={filters.districtId || undefined}
                    onChange={value => onChange({districtId: value || ""})}
                />
            </Col>
            {showZoneManagement && (
                <Col xs={24} sm={12} md={6}>
                    <ZoneManagementSelect
                        showTitle={false}
                        allowClear
                        marginBottom="0px"
                        placeholder={t("list.filters.zoneManagement", {ns: "applications"})}
                        style={{width: "100%"}}
                        value={filters.zoneManagementId || undefined}
                        onChange={value => onChange({zoneManagementId: value || ""})}
                    />
                </Col>
            )}
            <Col xs={24} sm={12} md={6}>
                <Select
                    allowClear
                    placeholder={t("list.filters.status", {ns: "applications"})}
                    value={filters.status || undefined}
                    onChange={value => onChange({status: value || ""})}
                    style={{width: "100%"}}
                >
                    {APPLICATION_STATUSES.map(status => (
                        <Select.Option key={status} value={status}>
                            {t(`statuses.${status}`, {ns: "applications"})}
                        </Select.Option>
                    ))}
                </Select>
            </Col>
            <Col xs={24} sm={12} md={6}>
                <DebouncedInput
                    value={filters.search}
                    placeholder={t(`list.filters.${isAgency ? "searchAgency" : "searchCompany"}`, {
                        ns: "applications"
                    })}
                    onChange={handleSearchChange}
                />
            </Col>
            {extra && (
                <Col flex="auto" style={{textAlign: "right"}}>
                    {extra}
                </Col>
            )}
        </Row>
    );
};
